"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useOnOutsideClick", {
    get: ()=>_useOnOutsideClick.useOnOutsideClick,
    enumerable: true
});
const _useOnOutsideClick = require("./useOnOutsideClick");
